"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFractionalDigits = void 0;
var getFractionalDigits = function (value) {
    if (!Number.isFinite(value)) {
        return 0;
    }
    var stringValue = value.toString();
    var decimalString = stringValue.includes('e') ? value.toFixed(20) : stringValue;
    var parts = decimalString.split('.');
    return parts[1] ? parts[1].replace(/0+$/, '').length : 0;
};
exports.getFractionalDigits = getFractionalDigits;
//# sourceMappingURL=get-fractional-digits.js.map